import { ReactComponent as EstablishmentIcon } from '../assets/icons/resort.svg';
import { ReactComponent as ProductsIcon } from '../assets/icons/products.svg';
import { ReactComponent as MediaIcon } from '../assets/icons/media.svg';
import { ReactComponent as AdminIcon } from '../assets/icons/users.svg';
import { ReactComponent as PackageIcon } from '../assets/icons/package.svg';
import { ReactComponent as StockIcon } from '../assets/icons/stock.svg';
import { ReactComponent as PriceIcon } from '../assets/icons/price.svg';
import { ReactComponent as SeasonIcon } from '../assets/icons/season.svg';
import SCOPE from '../utils/gate/scope';

const sidebarMenuEntries = [
  {
    path: '/admin',
    label: 'sidebarMenu.admin',
    icon: <AdminIcon />,
    permScope: [SCOPE.get_est_adminAccount, SCOPE.get_pla_adminAccount, SCOPE.get_ownEst_adminAccount],
  },
  // {
  //   path: '/establishment',
  //   label: 'sidebarMenu.establishment',
  //   icon: <EstablishmentIcon />,
  // },
  {
    path: '/establishments',
    label: 'sidebarMenu.establishments',
    icon: <EstablishmentIcon />,
    permScope: [SCOPE.get_pla_establishment],

  },
  {
    path: '/packages',
    label: 'sidebarMenu.packages',
    icon: <PackageIcon />,
    permScope: [SCOPE.get_ownEst_package],
  },
  {
    label: 'sidebarMenu.products',
    icon: <ProductsIcon />,
    permScope: [SCOPE.get_ownEst_camp, SCOPE.get_ownEst_extra, SCOPE.get_ownEst_accommodation],
    subLevels: [
      {
        path: '/products/camps',
        label: 'sidebarMenu.camps',
        permScope: [SCOPE.get_ownEst_camp],
      },
      {
        path: '/products/extras',
        label: 'sidebarMenu.extras',
        permScope: [SCOPE.get_ownEst_extra],
      },
      {
        path: '/products/accommodations',
        label: 'sidebarMenu.accommodations',
        permScope: [SCOPE.get_ownEst_accommodation],
      },
    ],
  },
  {
    label: 'sidebarMenu.stocks',
    icon: <StockIcon />,
    permScope: [SCOPE.get_ownEst_inventory],
    subLevels: [
      {
        path: '/stocks/camps',
        label: 'sidebarMenu.camps',
      },
      {
        path: '/stocks/extras',
        label: 'sidebarMenu.extras',
      },
      {
        path: '/stocks/accommodations',
        label: 'sidebarMenu.accommodations',
      },
    ],
  },
  {
    label: 'sidebarMenu.yields',
    icon: <PriceIcon />,
    permScope: [SCOPE.get_ownEst_inventory],
    subLevels: [
      {
        path: '/yields/camps',
        label: 'sidebarMenu.camps',
      },
      {
        path: '/yields/extras',
        label: 'sidebarMenu.extras',
      },
      {
        path: '/yields/accommodations',
        label: 'sidebarMenu.accommodations',
      },
    ],
  },
  {
    path: '/medias',
    label: 'sidebarMenu.medias',
    icon: <MediaIcon />,
    permScope: [SCOPE.get_pla_media, SCOPE.get_ownEst_media],
  },
  {
    path: '/seasons',
    label: 'sidebarMenu.seasons',
    icon: <SeasonIcon />,
    permScope: [SCOPE.get_ownEst_season],
  },
];

export default sidebarMenuEntries;
